var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",staticStyle:{"height":"100vh","width":"100vw"},attrs:{"id":_vm.id + '_container'}})}
var staticRenderFns = []

export { render, staticRenderFns }